import events from 'events-bus';

import Constants from '../Constants';

export default class BonusPoints {
  static init() {
    events.on(Constants.EVENT.BALANCE.GET_BALANCE, () => {
      events.post(Constants.EVENT.BALANCE.GET_BALANCE_SUCCESS);
    });
  }

  static onBalanceGet(onSuccess: any, onError: any) {
    if (onSuccess) {
      events.on(Constants.EVENT.BALANCE.GET_BALANCE_SUCCESS, onSuccess);
    }

    if (onError) {
      events.on(Constants.EVENT.BALANCE.GET_BALANCE_FAILURE, onError);
    }
  }

  static onBalanceGetOne(onSuccess: any, onError: any) {
    if (onSuccess) {
      events.consumeOne(Constants.EVENT.BALANCE.GET_BALANCE_SUCCESS, onSuccess);
    }

    if (onError) {
      events.consumeOne(Constants.EVENT.BALANCE.GET_BALANCE_FAILURE, onError);
    }
  }

  static getBalance() {
    return events.post(Constants.EVENT.BALANCE.GET_BALANCE);
  }
}
